const en = {
  menu1: "Home",
  menu2: "IDO",
  menu3: "Game ecosystem",
  menu4: "Xsparkpool Syrup Pool",
  menu5: "Machine gun pit",
  notAnZ: "log in Wallet",
  logout: "Log out", 
  logTip:'Please log in to your wallet first', 
  buyBtn: "Buy Sparky",
  panel1:'European and Italian Joint Development',
  panel2:'Fair and Just DAO',
  panel3:'High equity dividends',
  Equity:'Equity Data Panel',
  Profits:'Black Hole Profits',
  Principal:'Principal',
  Received:'Received',
  returns:'LP returns',
  total:"The total number of XSparks that have entered the black hole is ",
  Benefits:'What is XSPARK/ X-chain Spark?',
  BenefitsInfo1:'A secure, fair and transparent digital platform has been built by the participant CTODAO, serving users in numerous countries and regions around the world',
  BenefitsInfo2:'The multi-original ecology inspires infinite possibilities',
  BenefitsInfo3:'The DEFI ecosystem integrates syrup pools',
  BenefitsInfo4:'+ Machine gun pit',
  BenefitsInfo5:'+ Chain game',
  BenefitsInfo6:'+ Swap fee distribution',
  BenefitsInfo7:'+ BTC mining farms, etc',
  BenefitsInfo8:'Led by technological innovation',
  BenefitsInfo9:'Cutting-edge blockchain technology leads the new era of the digital economy',
  profile1:"The XSPARK token and ecosystem are both developed by the Ouyi technical team, with the base pool deployed on XLAYERSWAP and assisted in auditing by it. The Spark Grant Foundation, jointly established by retail investors, operates under the CTODAO governance model to initiate retail investors' joint manipulation, providing 'Innovative Sparks' for high-quality ecosystem developers on the X-chain.",
  profile2:'Innovative technological development and fair, just and transparent community governance and token distribution economics are bound to make it the leading community in Xlayer.',
  tixiTitle:'Build a diversified financial system through the following innovations',
  tixiSubtitle1:'Deflationary scarcity',
  tixiDes1:'The black hole destroys 1.5 times the OKB gains of the gold standard',
  tixiDes2:'Buyback and destruction drive long-term value growth and enhance the scarcity attribute of tokens',
  tixiDes3:'Ecological use: consumption + destruction',
  tixiSubtitle2:'Diversified income',
  tixiDes4:'Multiple returns such as market making, co-construction, and dividends meet different needs',
  tixiDes5:'The intelligent strategy of the bottom pool incentive promotes the continuous growth of the LP bottom pool and enhances the resilience of the ecosystem funds',
  tixiDes6:'On-chain data reading does not require staking. LPS automatically enter the syrup pool to obtain a series of dividends and governance rights',
  tixiSubtitle3:'The DAO autonomous community is jointly built and shared',
  tixiDes7:'Achieve a high degree of consensus and enhance community cohesion',
  youshiTitle:'The core advantages of XSPARK',
  youshiDes1:'The Spark Foundation has made a special investment of 5 million US dollars to support the development of market clubs and community studios around the world for the xsparkDAO governance protocol',
  youshiDes2:'A variety of welfare opportunities and rich welfare policies are in place. We sincerely invite you to participate and share the dividends of development',
  youshiDes3:'The global market traffic bridge connects tens of thousands of users and developers worldwide, with massive exposure, accelerating the intercommunication of technology and ecosystem',
  youshiDes4:'The major exchanges have joined forces to build a consensus x chain, the first DAO to govern the growth process of Longyi Community',
  nodePresale:'XSpark Node Presale',
  Whitelist:'Whitelist',
  yes:'Yes',
  no:'No',
  isWhite:'You are not a whitelist user',
  Price:'Price',
  TotalQuantity:'Total quantity',
  Sold:'Sold',
  buyBtn1: "Buy",
  parentAddress:'Parent address',
  General:'XSpark General Pre-sale',
  purchased:'I purchased',
  node:'Node',
  presale:'Pre-sale',
  Recommendation:'My Recommendation',
  recNum:'Recommended number',
  Referral:'Referral reward',

  success: " Success",
  failed: " Failure",  
  copy: "Copy referral link",  
  quxiao: "Cancle",
  shouquan: "Authorization",
};
export default en;
